import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, Activity, BarChart3, Loader2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { supabase } from "@/integrations/supabase/client";

const PlatformAnalytics = () => {
  const { language } = useLanguage();
  const bn = language === "bn";
  const [loading, setLoading] = useState(true);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalConversations, setTotalConversations] = useState(0);
  const [totalPayments, setTotalPayments] = useState(0);

  useEffect(() => {
    Promise.all([
      supabase.from("profiles").select("id", { count: "exact", head: true }),
      supabase.from("conversations").select("id", { count: "exact", head: true }),
      supabase.from("payments").select("id", { count: "exact", head: true }),
    ]).then(([u, c, p]) => {
      setTotalUsers(u.count ?? 0);
      setTotalConversations(c.count ?? 0);
      setTotalPayments(p.count ?? 0);
    }).finally(() => setLoading(false));
  }, []);

  const stats = [
    { icon: Users, labelEn: "Total Users", labelBn: "মোট ব্যবহারকারী", value: totalUsers },
    { icon: Activity, labelEn: "Conversations", labelBn: "কথোপকথন", value: totalConversations },
    { icon: BarChart3, labelEn: "Payments", labelBn: "পেমেন্ট", value: totalPayments },
  ];

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <div className="grid grid-cols-3 gap-4">
        {stats.map((s, i) => (
          <Card key={i} className="bg-card/60 backdrop-blur-sm border-border/40 hover:border-primary/30 transition-all hover:shadow-md">
            <CardContent className="p-5">
              <div className="flex items-center justify-between mb-3">
                <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center"><s.icon className="h-5 w-5 text-primary" /></div>
                {loading && <Loader2 className="h-3 w-3 animate-spin text-muted-foreground" />}
              </div>
              <p className="text-2xl font-extrabold tracking-tight">{s.value.toLocaleString()}</p>
              <p className="text-xs text-muted-foreground mt-1">{bn ? s.labelBn : s.labelEn}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="bg-card/60 backdrop-blur-sm border-border/40">
        <CardContent className="flex flex-col items-center justify-center py-16 text-center">
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#e4f1eb]">
            <BarChart3 className="h-7 w-7 text-primary/50" />
          </div>
          <p className="text-sm text-muted-foreground">{bn ? "বিস্তারিত বিশ্লেষণ শীঘ্রই আসছে" : "Detailed analytics coming soon"}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PlatformAnalytics;
